import React, { PropTypes } from 'react'

import ProfileMobileNavBar from 'components/ProfileMobileNavBar'

const RescheduleNavBar = ({ aliada, leftControlAction }) => {
  return (
    <ProfileMobileNavBar back>
      Disponibilidad {aliada && `de ${aliada.firstName}`}
    </ProfileMobileNavBar>
  )
}

RescheduleNavBar.displayName = 'RescheduleNavBar'
RescheduleNavBar.propTypes = {
  aliada: PropTypes.shape({
    firstName: PropTypes.string.isRequired
  })
}

export default RescheduleNavBar



// WEBPACK FOOTER //
// ./src/screens/App/screens/Services/screens/Reschedule/components/RescheduleNavBar/RescheduleNavBar.js